export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/aboutUsEn.05cb1679.svg","height":326,"width":1440,"blurWidth":0,"blurHeight":0};